import { Box, Button, Divider, Grid, Paper, Typography, TextField, InputAdornment, Tabs, Tab, Menu, MenuItem, InputLabel, FormControl } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import React, { useContext, useEffect, useState, ChangeEvent } from 'react';
import { useStyles } from '../styles';
import AddIcon from '@mui/icons-material/Add';
import Images from '../../../Assets/assetHelper';
import { useNavigate } from 'react-router-dom';
import routes from '../../../Utils/routes';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import { AuthUser } from '../../../interfaces/Contexts';
import { getallGroup } from '../../../Utils/apiService';
import YourGroupCard from '../components/YourGroupCard.tsx';
import CloseIcon from '@mui/icons-material/Close';
import CreatedGroupCard from '../components/CreatedGroupCard.tsx';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{
        p: 3,
        '@media (max-width:626px)': {
          padding: '0px !important',
        },
      }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const YourGroups = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [value, setValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [category, setCategory] = useState('');
  const [location, setLocation] = useState('');
  const {
    state: { user } } = useContext(AuthContext);
  const userData = user as AuthUser;
  const [memberGroups, setMemberGroups] = useState<any[]>([]);
  const [yourGroups, setYourGroups] = useState<any[]>([]);
  const [filteredMemberGroups, setFilteredMemberGroups] = useState<any[]>([]);
  const [filteredYourGroups, setFilteredYourGroups] = useState<any[]>([]);

  useEffect(() => {
    getallGroup(userData?.applicantId).then((res) => {
      const members = [
        { name: 'John Doe', imageUrl: Images.Images.DefaultProfileImage },
        { name: 'Jane Smith', imageUrl: Images.Images.DefaultProfileImage },
        { name: 'Alex Johnson', imageUrl: Images.Images.DefaultProfileImage },
      ];

      const memberGroupsData = res?.data?.data?.memberGroups?.map((group: any) => ({
        groupName: group.Title__c,
        memberCount: group.Member_Count__c,
        members: members,
        id: group.Id,
        contactId: group.Contact__c,
        type: group.Type__c,
        createdDate: group.CreatedDate,
        coverImage: group.Cover_Image_Url__c,
        Location__c: group.Location__c,
        tags: group.Tags__c,
        Description__c: group.Description__c,
      })) || [];

      const yourGroupsData = res?.data?.data?.createdGroups?.map((group: any) => ({
        groupName: group.Title__c,
        memberCount: group.Member_Count__c,
        members: members,
        id: group.Id,
        contactId: group.Contact__c,
        type: group.Type__c,
        createdDate: group.CreatedDate,
        coverImage: group.Cover_Image_Url__c,
        Location__c: group.Location__c,
        tags: group.Tags__c,
        Description__c: group.Description__c,
        Approval_Status__c : group.Approval_Status__c
      })) || [];

      setMemberGroups(memberGroupsData);
      setYourGroups(yourGroupsData);
      setFilteredMemberGroups(memberGroupsData);
      setFilteredYourGroups(yourGroupsData);
    });
  }, [userData?.applicantId]);

  const handleChangeCategory = (event: SelectChangeEvent) => {
    setCategory(event.target.value as string);
  };

  const handleChangeLocation = (event: SelectChangeEvent) => {
    setLocation(event.target.value as string);
  };

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    clearFilters();
    setSearchTerm('');
  };
  const ismobile = window.innerWidth <= 626;
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);

    const filteredMembers = memberGroups.filter(group =>
      (group.tags && group.tags.toLowerCase().includes(term)) ||
      (group.Description__c && group.Description__c.toLowerCase().includes(term)) ||
      (group.groupName && group.groupName.toLowerCase().includes(term))
    );

    const filteredYours = yourGroups.filter(group =>
      (group.tags && group.tags.toLowerCase().includes(term)) ||
      (group.Description__c && group.Description__c.toLowerCase().includes(term)) ||
      (group.groupName && group.groupName.toLowerCase().includes(term))
    );

    setFilteredMemberGroups(filteredMembers);
    setFilteredYourGroups(filteredYours);
  };

  const applyFilters = () => {
    let filteredMembers = memberGroups;
    let filteredYours = yourGroups;

    if (category) {
      filteredMembers = filteredMembers.filter(group => group.type === category);
      filteredYours = filteredYours.filter(group => group.type === category);
    }

    if (location) {
      filteredMembers = filteredMembers.filter(group => group.Location__c === location);
      filteredYours = filteredYours.filter(group => group.Location__c === location);
    }

    setFilteredMemberGroups(filteredMembers);
    setFilteredYourGroups(filteredYours);
    handleClose();
  };

  const clearFilters = () => {
    setCategory('');
    setLocation('');
    setFilteredMemberGroups(memberGroups);
    setFilteredYourGroups(yourGroups);
  };

  const handleCreateGroup = () => {
    navigate(routes.createGroup);
  };

  return (
    <Grid item spacing={3} height={'97%'} overflow={'hidden'}>
      <Paper className={`${classes.DiscoverGroupContainer}`}>
        <Box sx={{
          '@media (max-width:626px)': {
            flexDirection: 'column',
            alignItems: 'normal',
          },
        }} className={classes.DiscoverGroupContainerHeader}>
          <Box sx={{ flex: '1' }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Your groups" {...a11yProps(0)} sx={{ textTransform: 'none', fontSize: '15px', fontWeight: 500 }} />
              <Tab label="Created by you" {...a11yProps(1)} sx={{ textTransform: 'none', fontSize: '15px', fontWeight: 500 }} />
            </Tabs>
          </Box>
          <Box sx={{
            '@media (max-width:626px)': {
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
            },
          }}>
            {!ismobile && (
              <TextField
                placeholder="Search"
                variant="outlined"
                value={searchTerm}
                size="small"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                    height: '36px',
                  },
                  '& .MuiInputBase-input': {
                    fontSize: '12px',
                  },
                }}
                onChange={handleSearchChange}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ fontSize: '15px' }} />
                    </InputAdornment>
                  ),
                }}
              />
            )}
            {ismobile && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <TextField
                  placeholder="Search"
                  variant="outlined"
                  value={searchTerm}
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '10px',
                      height: '36px',
                    },
                    '& .MuiInputBase-input': {
                      fontSize: '12px',
                    },
                  }}
                  onChange={handleSearchChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon style={{ fontSize: '15px' }} />
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  style={{ textTransform: 'capitalize' ,color :'#5B4200'}}
                  size="large"
                  variant="contained"
                  startIcon={<AddIcon style={{ fontSize: '15px' }} />}
                  sx={{
                    borderRadius: '6px',
                    ml: 1,
                    boxShadow: 'none',
                    height: '36px',
                    '&:hover': {
                      boxShadow: 'none',
                    },
                    '@media (max-width:626px)': {
                      marginLeft: '0px',
                    },
                  }}
                  onClick={handleCreateGroup}
                >
                  <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Group</Typography>
                </Button>
                <Button
                  sx={{
                    borderRadius: '6px',
                    backgroundColor: '#E8EBF3',
                    color: '#373A45',
                    height: '36px',
                  }}
                  aria-controls={open ? 'basic-menu' : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                  onClick={handleClick}
                >
                  <FilterAltOutlinedIcon style={{ fontSize: '15px' }} />
                </Button>
              </Box>
            )}
            {!ismobile && (
              <Button
                style={{ textTransform: 'capitalize' }}
                size="large"
                startIcon={<FilterAltOutlinedIcon style={{ fontSize: '15px' }} />}
                sx={{
                  borderRadius: '6px', ml: 1, backgroundColor: '#E8EBF3', color: '#373A45', height: '36px',
                  '@media (max-width:626px)': {
                    marginLeft: '0px',
                  },
                }}
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Filters</Typography>
              </Button>)}
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
              PaperProps={{
                sx: {
                  width: '20vw',
                  height: '72vh',
                  padding: '20px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  '@media (max-width:626px)': {
                    width: '90vw',
                    height: '70vh',
                    padding: '10px',
                  },
                },
              }}
              sx={{ mt: 2 }}
            >
              <Grid container>
                <Grid item xs={11}>
                  <Typography sx={{ fontWeight: 550, fontSize: 18 }}>Filters</Typography>
                </Grid>
                <Grid item xs={1}>
                  <Typography onClick={handleClose}>
                    <CloseIcon />
                  </Typography>
                </Grid>
              </Grid>
              <Box sx={{ height: '52vh' }}>
                <Box sx={{ width: '100%', mt: 3 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" sx={{ fontSize: '12px', marginTop: '-7px' }}>
                      Category
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={category}
                      label="Category"
                      onChange={handleChangeCategory}
                      sx={{
                        height: '36px',
                        borderRadius: '6px',
                        '& .MuiOutlinedInput-root': {
                          height: '36px',
                          borderRadius: '6px',
                        },
                      }}
                    >
                      <MenuItem value="Public">Public</MenuItem>
                      <MenuItem value="Private">Private</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Box sx={{ width: '100%', mt: 3 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label" sx={{ fontSize: '12px', marginTop: '-7px' }}>
                      Location
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={location}
                      label="Location"
                      onChange={handleChangeLocation}
                      sx={{
                        height: '36px',
                        borderRadius: '6px',
                        '& .MuiOutlinedInput-root': {
                          height: '36px',
                          borderRadius: '6px',
                        },
                      }}
                    >
                      {Array.from(new Set([...memberGroups, ...yourGroups].map(group => group.Location__c))).map((loc, index) => (
                        <MenuItem key={index} value={loc}>{loc}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Box>
              <Box>
                <Divider sx={{ paddingTop: '10px', color: '#BFCEFF', marginBottom: '10px' }} />
                <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'end' }}>
                  <Button
                    style={{ textTransform: 'capitalize' }}
                    size="large"
                    variant="text"
                    sx={{ borderRadius: '6px', ml: 1, fontSize: '12px', fontWeight: '500', width: '100%' }}
                    onClick={clearFilters}
                  >
                    Clear
                  </Button>
                  <Button
                    style={{ textTransform: 'capitalize',color :'#5B4200' }}
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: '6px',
                      ml: 1,
                      fontSize: '12px',
                      fontWeight: '500',
                      width: '100%',
                      boxShadow: 'none',
                      '&:hover': {
                        boxShadow: 'none',
                      },
                    }}
                    onClick={applyFilters}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Menu>
            {!ismobile && (<Button
              style={{ textTransform: 'capitalize',color :'#5B4200' }}
              size="large"
              variant="contained"
              startIcon={<AddIcon style={{ fontSize: '15px' }} />}
              sx={{
                borderRadius: '6px',
                ml: 1,
                boxShadow: 'none',
                height: '36px',
                '&:hover': {
                  boxShadow: 'none',
                },
                '@media (max-width:626px)': {
                  marginLeft: '0px',
                },
              }}
              onClick={handleCreateGroup}
            >
              <Typography sx={{ fontSize: '12px', fontWeight: 500 }}>Create Group</Typography>
            </Button>)}
          </Box>
        </Box>
        <Divider sx={{ paddingTop: '10px', color: '#BFCEFF', marginBottom: '10px' }} />
        <Box className={`scrollbar-cusgray ${classes.postContainer1}`}>
          <Box
            sx={{
              marginTop: '5px',
              height: 'auto',
              paddingRight: '5px',
              overflowY: 'auto',
              paddingBottom: '50px',
            }}
          >
            <CustomTabPanel value={value} index={0}>
              {filteredMemberGroups.length > 0 ? (
                <Grid container spacing={2}>
                  {filteredMemberGroups.map((group: any, index: React.Key | null | undefined) => (
                    <Grid key={index} item xs={6} sm={6} md={4} lg={3} sx={{ cursor: 'pointer' }}>
                      <YourGroupCard {...group} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <img src={Images.Images.NoDataTheme} alt="No Data Available" style={{ width: '100px', height: '100px' }} />
                  <Typography>Currently, no groups are available for you!</Typography>
                </Box>
              )}
            </CustomTabPanel>

            <CustomTabPanel value={value} index={1}>
              {filteredYourGroups.length > 0 ? (
                <Grid container spacing={2}>
                  {filteredYourGroups.map((group: any, index: React.Key | null | undefined) => (
                    <Grid key={index} item xs={6} sm={6} md={4} lg={3} sx={{ cursor: 'pointer' }}>
                      <CreatedGroupCard {...group} />
                    </Grid>
                  ))}
                </Grid>
              ) : (
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                  <img src={Images.Images.NoDataTheme} alt="No Data Available" style={{ width: '100px', height: '100px' }} />
                  <Typography>Currently, no groups are available for you!</Typography>
                </Box>
              )}
            </CustomTabPanel>
          </Box>
        </Box>
      </Paper>
    </Grid>
  );
};

export default YourGroups;